import notitles from "../../../../../images/notitles.png";

export const AdvIndex = () => {
    return (
		<>
            <center>
                <div>
                    <img src={notitles} style={{width: '50%'}} alt="" />
                </div>
                <div style={{ fontSize: '26px', color: 'grey', marginTop: '30px'}}>
                    Funzione disponibile entro il 31 Dicembre 2025!
                </div>
                <div style={{ fontSize: '16px', color: 'grey', fontWeight: '300', marginTop: '20px'}}>
                    Stay Tuned!
                    <br></br>
                    Questa funzione è in fase di realizzazione e sarà presto disponibile.
                </div>
            </center>
        </>
    )
}

export default AdvIndex;